// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5cf0243c","336":"b1b0f651","455":"91cf9b81","977":"bd26d558"}[chunkId] + ".chunk.js";
};